/*
 * image
 */
import { cn } from "@timeprox/react/helpers"
import { DetailedHTMLProps, ImgHTMLAttributes } from "react"

export type ImageProps = DetailedHTMLProps<
	ImgHTMLAttributes<HTMLImageElement>,
	HTMLImageElement
> & {
	background?: boolean
}

export function Image({ background = false, className, ...props }: ImageProps) {
	return (
		<img {...props} className={cn(background && "h-full w-full", className)} />
	)
}
